import { Pipe, PipeTransform, Input } from '@angular/core';
import { AuthService } from '../services/auth.service';
import * as _ from 'lodash';
import { normalizeCaseAndAccents } from '../utils/functions';
import moment from 'moment';
import { DateService } from '../services/date.service';
import levenshtein from 'js-levenshtein';

@Pipe({ name: 'sort' ,pure:false})
export class SortPipe implements PipeTransform {

    constructor() {
    }

    transform(items, sortConfig) {
        if (sortConfig && sortConfig.key && sortConfig.order){
            return sortConfig.order === 1 ? this.sort(items,sortConfig.key) : _.reverse(this.sort(items,sortConfig.key))
        } else {
            return _.reverse(items);
        }
    }

    sort(items,key){
        return _.sortBy(items, (i) => {
            return i[key]
        })
    }
}